import axios from "axios";
import { IPaymentType } from "../models/paymentType";

export const getPaymentTypes = async () => {
    const res = await axios.get("/api/paymentTypes");
    return res.data as IPaymentType;
};
export const editPaymentTypeAsync = async (data: IPaymentType) => {
    await axios.patch("/api/paymentTypes", data);
};

export const fetchPaymentTypeByGuid = async (guid: string) => {
    const res = await axios.get(`/api/paymentTypes/${guid}`);
    return res.data as IPaymentType;
};

export const deletePaymentTypeByGuid = async (guid: string) => {
    await axios.delete(`/api/paymentTypes/${guid}`);
};

export const orderPaymentType = async (guid: string, orderDirection: boolean) => {
    await axios.post(`/api/paymentTypes/${guid}/order/${orderDirection}`);
};

export const createPaymentType = async (data: IPaymentType) => {
    await axios.post("/api/paymentTypes", data);
};
